import template from './template.hbs';
import UserInfoFactory from '../../../../factory/user-info';

module.exports = Backbone.View.extend({
  initialize: async function (opts) {
    if (!INKIVE.C.IS_MOBILE) {
      CONFIG.welcomeTour = opts.data.welcomeTour;
      if (opts.data.isDesygner) {
        await this.initDesygnerCoachmarks();
        INKIVE.EditorFacade.on('coachmarks:start-editor-tour', () => {
          this.started || this._initCoachmarkListener();
          this.started = true;
        });
      }
      this.render();

      const $widgetContainer = this.$el.children('.widget-container');
      INKIVE.Helpers.getAureliaLibraries($widgetContainer.find('[aurelia-app="coach-marks/main"]'));
    }
  },

  initDesygnerCoachmarks: async function () {
    const userData = await UserInfoFactory.get();

    if (UserInfoFactory.isFirstAccess(userData)) {
      INKIVE.EditorFacade.once('add.filemenu', () => INKIVE.EditorFacade.trigger('coachmarks:start-editor-tour'));
    }
  },

  _initCoachmarkListener () {
    INKIVE.EditorFacade.on('select', (elem) => {
      if (elem.length !== 1) {
        return;
      }
      const isImage = elem[0].type === 'image' || (elem[0].type === 'background' && elem[0].source);

      isImage && setTimeout(() => INKIVE.EditorFacade.trigger('first-time-image-selected'), 500);
      elem[0].type === 'text' && setTimeout(() => INKIVE.EditorFacade.trigger('first-time-text-selected'), 500);
    });
  },

  render: function () {
    this.$el.html(template());
  }
});
